import React, { useRef } from "react";
import { skills, experience, ExperianceType } from "./types";
import { useTranslation, Trans } from "react-i18next";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import "./Skills.scss";

gsap.registerPlugin(ScrollTrigger);

const Skills = () => {
  const {i18n} = useTranslation();
  let currentExperience: ExperianceType[] = experience.en;
  for (const [key, value] of Object.entries(experience)) {
    if (key === i18n.resolvedLanguage) {
      currentExperience = value;
    }
  }

  const title = useRef(null);
  const container = useRef(null);
  const experienceList = useRef('.experience__item')

  useGSAP(() => {
    gsap.set(title.current, {xPercent: -100, opacity: 0})
    gsap.to(title.current, {
      scrollTrigger: title.current,
      opacity: 1, 
      xPercent: 0, 
      duration: 1, 
      ease: "slow",
    });
    gsap.fromTo('.skills__item', {
      opacity: 0,
    }, {
      scrollTrigger: '.skills__list',
      opacity: 1,
      duration: 1, 
      ease: "slow", 
      stagger: 0.2,
      delay: 1 
    });
    gsap.fromTo(experienceList.current, {
      opacity: 0,
      yPercent: 100
    }, {
      scrollTrigger: experienceList.current,
      opacity: 1,
      yPercent: 0,
      duration: 1, 
      ease: "slow", 
      stagger: 0.5,
      delay: 1.5 
    });
  }, { scope: container })

  return (
    <section id="skills" className="skills" ref={container}>
      <div className="container h-full">
          <h2 className="app__title skills__title" ref={title}>
            <Trans i18nKey="skills_title">
              Skills & Relevant experience
            </Trans>
          </h2>
        <div className="skills__container">
          <div className="skills__block">
            <div className="skills__list">
              {skills
                .sort((a, b) => a.id - b.id)
                .map((item) => (
                  <div
                    key={`skill-${item.id}`}
                    className="skills__item"
                  >
                    <img
                      src={`${item.icon}`}
                      alt={`${item.name}`}
                      height={35}
                      width={'auto'}
                    />
                    <p className="skills__item-name">{item.name}</p>
                  </div>
                ))}
            </div>
          </div>
          <div className="experience__block">
            {currentExperience.sort((a,b) => a.id - b.id).map((item) => (
              <div
                key={`index${item.id}`}
                className="experience__item"
              >
                <div className="experience__date">{item.date}</div>
                <div className="experience__value">
                  <p className="experience__title">{item.name}</p>
                  <p className="experience__company">{item.company}</p>
                  <ul className="experience__disc">
                    {item.desc.map((item, index) => (
                      <li key={`desc-${index}`}>{item}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
